/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>

(function($, _) {
  var ns = window.nspace("ccc.viz.selectors");

  ns.LocationTypeSelectorView = ns.BaseSelectorView.extend({
    name: "Location Type Selector",
    el: "#location-type-selector",
    // templateSelector: "#location-type-selector-template",
    template: _.template(
      [
        '<div class="filter-block location-type">',
        '<span class="filter-type-text">Location Type</span>',
        "<% for (var i = 0; i < locationTypes.length; i++) {",
        "var locationType = locationTypes[i];",
        "if (locationType.selected == true){",
        "%>",
        '<div class="radio-container"><input type="radio" name="loc" id="location-type-radio<%=locationType.id%>" value="<%=locationType.id%>" checked data-text="<%=locationType.name%>"><label class="radioLabel" for="location-type-radio<%=locationType.id%>"><%=locationType.name%></label></div>',
        "<% } else {%>",
        '<div class="radio-container"><input type="radio" name="loc" id="location-type-radio<%=locationType.id%>" value="<%=locationType.id%>" data-text="<%=locationType.name%>"><label class="radioLabel" for="location-type-radio<%=locationType.id%>"><%=locationType.name%></label></div>',
        "<%}}%>",
        "</div>"
      ].join("\n")
    ),
    propertyName: "locationTypeId",
    selectorInfoPropertyName: "locationTypes",
    initialize: function() {
      _.bindAll(this, "onChangeUpdateModel", "initializeModel", "updateDOM");
    },

    events: {
      change: "onChangeUpdateModel"
    },

    onChangeUpdateModel: function() {
      var props = {};
      var $dropdown = $(".filter-block", this.$el);
      var dropdownValue = $dropdown.find("input:checked").val();
      props[this.propertyName] = dropdownValue;

      // If the location type is changing, then we also need to clear any
      // selected location (since it will be of a different location type than we're switching to)
      if (this.model.get(this.propertyName) !== props[this.propertyName]) {
        props["selectedFips"] = null;
      }

      this.model.set(props);

      // Tracks if user changes location type on the "Explore Data" page
      var selector = "input[value=" + dropdownValue + "]";
      var communityName = $(selector, $dropdown).data("");
      dataLayer.push({
        event: "Location Type Dropdown Clicks",
        eventCategory: "Interactive Clicks",
        eventAction: "Location Type Dropdown|" + communityName,
        eventLabel: window.location.pathname
      });
    },

    initializeModel: function() {
      //set the model based on which value is checked
      var $radioActive = $(this.$el).find("input:checked").length
        ? $(this.$el).find(".radio-container input:checked")
        : $(this.$el).find(".radio-container input:first");

      this.model.set(this.propertyName, $radioActive.val(), {
        silent: true
      });
    },

    /**
     * Returns text summarizing the currently selected options for this selector.
     */
    getDataSummaryText: function() {
      return $(".filter-block input:checked", this.$el).data("text");
    },

    updateDOM: function() {
      // Set the option corresponding to the value on the model
      $(this.$el)
        .find(
          'input[value="' + this.model.get(this.propertyName) + '"]',
          this.$el
        )
        .prop("checked", true);
    }
  });
})(jQuery, _);
